/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as commonV1 from "./deviceapis_device_common_v1.pb"

/**
 * Сервис управления настройками Sip
 */

/**
 * Сервис управления Sip
 */
export class SipServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод редактирования Sip-аккаунта
   */
  EditSipAccount = (req: Pick<EditSipAccountRequestDto, "updateMask"> & { data: Pick<SipAccountRequestDto, "accountId"> & fm.RequireAtLeastOne<Omit<SipAccountRequestDto, "accountId">> }, init?: RequestInit): Promise<EditSipAccountResponseDto> => {
    return fm.request<Pick<EditSipAccountRequestDto, "updateMask"> & { data: Pick<SipAccountRequestDto, "accountId"> & fm.RequireAtLeastOne<Omit<SipAccountRequestDto, "accountId">> }, EditSipAccountResponseDto>(`${this.host}/device/api/v1/sip/account/${encodeURIComponent(req.data.accountId)}`, { ...init, method: "PATCH", body: JSON.stringify(req.data, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка Sip-аккаунтов
   */
  GetSipAccountList = (req?: GetSipAccountListRequestDto, init?: RequestInit): Promise<GetSipAccountListResponseDto> => {
    return fm.request<GetSipAccountListRequestDto, GetSipAccountListResponseDto>(`${this.host}/device/api/v1/sip/account/list${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод редактирования настроек максимального времени общения и дозвона
   */
  EditSipTimeoutSettings = (req: Pick<EditSipTimeoutSettingsRequestDto, "updateMask"> & { data: SipTimeoutSettingsRequestDto & fm.RequireAtLeastOne<SipTimeoutSettingsRequestDto> }, init?: RequestInit): Promise<EditSipTimeoutSettingsResponseDto> => {
    return fm.request<Pick<EditSipTimeoutSettingsRequestDto, "updateMask"> & { data: SipTimeoutSettingsRequestDto & fm.RequireAtLeastOne<SipTimeoutSettingsRequestDto> }, EditSipTimeoutSettingsResponseDto>(`${this.host}/device/api/v1/sip/timeout/settings`, { ...init, method: "PATCH", body: JSON.stringify(req.data, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения настроек максимального времени общения и дозвона
   */
  GetSipTimeoutSettings = (req?: GetSipTimeoutSettingsRequestDto, init?: RequestInit): Promise<GetSipTimeoutSettingsResponseDto> => {
    return fm.request<GetSipTimeoutSettingsRequestDto, GetSipTimeoutSettingsResponseDto>(`${this.host}/device/api/v1/sip/timeout/settings${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения статусов регистрации Sip-аккаунтов
   */
  GetSipAccountStatusList = (req?: GetSipAccountStatusListRequestDto, init?: RequestInit): Promise<GetSipAccountStatusListResponseDto> => {
    return fm.request<GetSipAccountStatusListRequestDto, GetSipAccountStatusListResponseDto>(`${this.host}/device/api/v1/sip/account/status/list${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Тип состояния Sip-аккаунта
 */
export enum GetSipAccountStatusListResponseSipStatusStateType {
  /**
   * Значение не указано
   */
  STATE_TYPE_UNKNOWN = "STATE_TYPE_UNKNOWN",
  /**
   * Клиент отправил REGISTER запрос, но ответ от сервера ещё не получен.
   * Идёт попытка регистрации
   */
  REGISTERING = "REGISTERING",
  /**
   * Успешная регистрация.
   * SIP-сервер подтвердил регистрацию, клиент готов принимать звонки
   */
  REGISTERED = "REGISTERED",
  /**
   * Клиент отключился или не регистрировался.
   * Возможные причины: Клиент отправил UNREGISTER; Истек срок регистрации (expires)
   */
  UNREGISTERED = "UNREGISTERED",
  /**
   * Ошибка при попытке регистрации.
   * Возможные причины: Неверный логин/пароль; SIP-сервер недоступен; Ошибка в конфигурации (порт, протокол, IP)
   */
  REGISTRATION_FAILED = "REGISTRATION_FAILED",
  /**
   * Нет ответа от сервера в течение времени ожидания.
   * Возможные причины: Проблемы с сетью; SIP-сервер не отвечает; Нет ответа от сервера в течение времени ожидания
   */
  TIMEOUT = "TIMEOUT",
  /**
   * SIP клиент остановлен вручную или отключён по конфигурации.
   * Не выполняется даже попытка регистрации
   */
  DISABLED = "DISABLED",
}
/**
 * Тип состояния Sip-аккаунта
 */
export type GetSipAccountStatusListResponseSipStatusStateTypeResponseEnum = keyof typeof GetSipAccountStatusListResponseSipStatusStateType
/**
 * Тип состояния Sip-аккаунта
 */
export type GetSipAccountStatusListResponseSipStatusStateTypeRequestEnum = Exclude<GetSipAccountStatusListResponseSipStatusStateTypeResponseEnum, "STATE_TYPE_UNKNOWN">;

/**
 * Запрос на редактирование Sip-аккаунта
 */
export type EditSipAccountRequestDto = {
  /**
   * Sip-аккаунт
   */
  data: SipAccountRequestDto
  /**
   * Маска полей обновления
   */
  updateMask?: string | null
}
/**
 * Ответ на запрос редактирования Sip-аккаунта
 */
export type EditSipAccountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: EditSipAccountResponseErrorDto
}>
/**
 * Ошибка запроса редактирования Sip-аккаунта
 */
export type EditSipAccountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса редактирования Sip-аккаунта
 */
export type EditSipAccountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Запрос редактирования настроек максимального времени общения и дозвона
 */
export type EditSipTimeoutSettingsRequestDto = {
  /**
   * Настройки максимального времени общения и дозвона
   */
  data: SipTimeoutSettingsRequestDto
  /**
   * Маска полей обновления
   */
  updateMask?: string | null
}
/**
 * Ответ на запрос редактирования настроек максимального времени общения и дозвона
 */
export type EditSipTimeoutSettingsResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: EditSipTimeoutSettingsResponseErrorDto
}>
/**
 * Ошибка запроса редактирования настроек максимального времени общения и дозвона
 */
export type EditSipTimeoutSettingsResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса редактирования настроек максимального времени общения и дозвона
 */
export type EditSipTimeoutSettingsResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения списка Sip-аккаунтов
 */
export type GetSipAccountListRequestDto = {
}
/**
 * Ответ на запрос получения списка Sip-аккаунтов
 */
export type GetSipAccountListResponseDto = {
  /**
   * Массив Sip-аккаунтов
   */
  data: SipAccountResponseDto[]
}
/**
 * Запрос получения статусов регистрации Sip-аккаунтов
 */
export type GetSipAccountStatusListRequestDto = {
}
/**
 * Ответ на запрос получения статусов регистрации Sip-аккаунтов
 */
export type GetSipAccountStatusListResponseDto = {
  /**
   * Статус аккаунтов Sip
   */
  data: GetSipAccountStatusListResponseSipStatusDto[]
}
/**
 * Статус аккаунтов Sip
 */
export type GetSipAccountStatusListResponseSipStatusDto = {
  /**
   * ID Sip-аккаунта
   */
  sipAccountId: string
  /**
   * Статус регистрации Sip
   */
  stateType: GetSipAccountStatusListResponseSipStatusStateTypeResponseEnum
  /**
   * Дата последней попытки регистрации UnixTime
   */
  lastAttemptRegisterAt: number
}
/**
 * Запрос получения настроек максимального времени общения и дозвона
 */
export type GetSipTimeoutSettingsRequestDto = {
}
/**
 * Ответ на запрос получения настроек максимального времени общения и дозвона
 */
export type GetSipTimeoutSettingsResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Настройки максимального времени общения и дозвона
   */
  readonly data: SipTimeoutSettingsResponseDto
}>
/**
 * Sip-аккаунт
 */
export type SipAccountRequestDto = {
  /**
   * ID Sip-аккаунта
   */
  accountId: string
  /**
   * Имя
   */
  name?: string | null
  /**
   * Номер
   */
  number?: string | null
  /**
   * Имя пользователя
   */
  user?: string | null
  /**
   * Пароль.
   * Не возвращается с сервера.
   * TODO: в генерации сваггера не показывать INPUT_ONLY поля в ответах
   */
  password: string
  /**
   * Адрес REG-сервера.
   * Сетевой адрес и порт.
   * Пример: 192.168.0.1:5060, reg.acme.io:5060
   */
  regServerAddress?: string | null
  /**
   * Адрес SIP-сервера.
   * Сетевой адрес и порт.
   * Пример: 192.168.0.1:5060, sip.acme.io:5060
   */
  sipServerAddress?: string | null
  /**
   * Адрес SIP-прокси.
   * Сетевой адрес и порт.
   * Пример: 192.168.0.1:5060, proxy.acme.io:5060
   */
  sipProxyAddress?: string | null
}
/**
 * Sip-аккаунт
 */
export type SipAccountResponseDto = {
  /**
   * ID Sip-аккаунта
   */
  accountId: string
  /**
   * Имя
   */
  name: string | null
  /**
   * Номер
   */
  number: string | null
  /**
   * Имя пользователя
   */
  user: string | null
  /**
   * Адрес REG-сервера.
   * Сетевой адрес и порт.
   * Пример: 192.168.0.1:5060, reg.acme.io:5060
   */
  regServerAddress: string | null
  /**
   * Адрес SIP-сервера.
   * Сетевой адрес и порт.
   * Пример: 192.168.0.1:5060, sip.acme.io:5060
   */
  sipServerAddress: string | null
  /**
   * Адрес SIP-прокси.
   * Сетевой адрес и порт.
   * Пример: 192.168.0.1:5060, proxy.acme.io:5060
   */
  sipProxyAddress: string | null
}
/**
 * Настройки максимального времени общения и дозвона
 */
export type SipTimeoutSettingsRequestDto = {
  /**
   * Максимальное время дозвона в секундах
   */
  callTimeout?: number
  /**
   * Максимальное время общения в секундах
   */
  talkTimeout?: number
}
/**
 * Настройки максимального времени общения и дозвона
 */
export type SipTimeoutSettingsResponseDto = {
  /**
   * Максимальное время дозвона в секундах
   */
  callTimeout: number
  /**
   * Максимальное время общения в секундах
   */
  talkTimeout: number
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос на редактирование Sip-аккаунта
   */
  "EditSipAccountRequest": {
    "kind": "class",
    "text": "Запрос на редактирование Sip-аккаунта",
    "fields": {
      /**
       * Sip-аккаунт
       */
      "data": {
        "type": "SipAccount",
        "text": "Sip-аккаунт",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Маска полей обновления
       */
      "updateMask": {
        "type": "google.protobuf.FieldMask",
        "text": "Маска полей обновления",
      },
    },
  },
  /**
   * Ответ на запрос редактирования Sip-аккаунта
   */
  "EditSipAccountResponse": {
    "kind": "class",
    "text": "Ответ на запрос редактирования Sip-аккаунта",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "EditSipAccountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса редактирования Sip-аккаунта
   */
  "EditSipAccountResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса редактирования Sip-аккаунта",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос редактирования настроек максимального времени общения и дозвона
   */
  "EditSipTimeoutSettingsRequest": {
    "kind": "class",
    "text": "Запрос редактирования настроек максимального времени общения и дозвона",
    "fields": {
      /**
       * Настройки максимального времени общения и дозвона
       */
      "data": {
        "type": "SipTimeoutSettings",
        "text": "Настройки максимального времени общения и дозвона",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Маска полей обновления
       */
      "updateMask": {
        "type": "google.protobuf.FieldMask",
        "text": "Маска полей обновления",
      },
    },
  },
  /**
   * Ответ на запрос редактирования настроек максимального времени общения и дозвона
   */
  "EditSipTimeoutSettingsResponse": {
    "kind": "class",
    "text": "Ответ на запрос редактирования настроек максимального времени общения и дозвона",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "EditSipTimeoutSettingsResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса редактирования настроек максимального времени общения и дозвона
   */
  "EditSipTimeoutSettingsResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса редактирования настроек максимального времени общения и дозвона",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения списка Sip-аккаунтов
   */
  "GetSipAccountListRequest": {
    "kind": "class",
    "text": "Запрос получения списка Sip-аккаунтов",
  },
  /**
   * Ответ на запрос получения списка Sip-аккаунтов
   */
  "GetSipAccountListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка Sip-аккаунтов",
    "fields": {
      /**
       * Массив Sip-аккаунтов
       */
      "data": {
        "type": "SipAccount",
        "text": "Массив Sip-аккаунтов",
      },
    },
  },
  /**
   * Запрос получения статусов регистрации Sip-аккаунтов
   */
  "GetSipAccountStatusListRequest": {
    "kind": "class",
    "text": "Запрос получения статусов регистрации Sip-аккаунтов",
  },
  /**
   * Ответ на запрос получения статусов регистрации Sip-аккаунтов
   */
  "GetSipAccountStatusListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения статусов регистрации Sip-аккаунтов",
    "fields": {
      /**
       * Статус аккаунтов Sip
       */
      "data": {
        "type": "GetSipAccountStatusListResponse.SipStatus",
        "text": "Статус аккаунтов Sip",
      },
    },
  },
  /**
   * Статус аккаунтов Sip
   */
  "GetSipAccountStatusListResponse.SipStatus": {
    "kind": "class",
    "text": "Статус аккаунтов Sip",
    "fields": {
      /**
       * ID Sip-аккаунта
       */
      "sipAccountId": {
        "type": "string",
        "text": "ID Sip-аккаунта",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Статус регистрации Sip
       */
      "stateType": {
        "type": "GetSipAccountStatusListResponse.SipStatus.StateType",
        "text": "Статус регистрации Sip",
      },
      /**
       * Дата последней попытки регистрации UnixTime
       */
      "lastAttemptRegisterAt": {
        "type": "int32",
        "text": "Дата последней попытки регистрации UnixTime",
      },
    },
  },
  /**
   * Запрос получения настроек максимального времени общения и дозвона
   */
  "GetSipTimeoutSettingsRequest": {
    "kind": "class",
    "text": "Запрос получения настроек максимального времени общения и дозвона",
  },
  /**
   * Ответ на запрос получения настроек максимального времени общения и дозвона
   */
  "GetSipTimeoutSettingsResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения настроек максимального времени общения и дозвона",
    "fields": {
      /**
       * Настройки максимального времени общения и дозвона
       */
      "data": {
        "type": "SipTimeoutSettings",
        "text": "Настройки максимального времени общения и дозвона",
      },
    },
  },
  /**
   * Sip-аккаунт
   */
  "SipAccount": {
    "kind": "class",
    "text": "Sip-аккаунт",
    "fields": {
      /**
       * ID Sip-аккаунта
       */
      "accountId": {
        "type": "string",
        "text": "ID Sip-аккаунта",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Имя
       */
      "name": {
        "type": "google.protobuf.StringValue",
        "text": "Имя",
      },
      /**
       * Номер
       */
      "number": {
        "type": "google.protobuf.StringValue",
        "text": "Номер",
      },
      /**
       * Имя пользователя
       */
      "user": {
        "type": "google.protobuf.StringValue",
        "text": "Имя пользователя",
      },
      /**
       * Пароль.
       * Не возвращается с сервера.
       * TODO: в генерации сваггера не показывать INPUT_ONLY поля в ответах
       */
      "password": {
        "type": "google.protobuf.StringValue",
        "text": "Пароль.\nНе возвращается с сервера.\nTODO: в генерации сваггера не показывать INPUT_ONLY поля в ответах",
      },
      /**
       * Адрес REG-сервера.
       * Сетевой адрес и порт.
       * Пример: 192.168.0.1:5060, reg.acme.io:5060
       */
      "regServerAddress": {
        "type": "google.protobuf.StringValue",
        "text": "Адрес REG-сервера.\nСетевой адрес и порт.\nПример: 192.168.0.1:5060, reg.acme.io:5060",
      },
      /**
       * Адрес SIP-сервера.
       * Сетевой адрес и порт.
       * Пример: 192.168.0.1:5060, sip.acme.io:5060
       */
      "sipServerAddress": {
        "type": "google.protobuf.StringValue",
        "text": "Адрес SIP-сервера.\nСетевой адрес и порт.\nПример: 192.168.0.1:5060, sip.acme.io:5060",
      },
      /**
       * Адрес SIP-прокси.
       * Сетевой адрес и порт.
       * Пример: 192.168.0.1:5060, proxy.acme.io:5060
       */
      "sipProxyAddress": {
        "type": "google.protobuf.StringValue",
        "text": "Адрес SIP-прокси.\nСетевой адрес и порт.\nПример: 192.168.0.1:5060, proxy.acme.io:5060",
      },
    },
  },
  /**
   * Настройки максимального времени общения и дозвона
   */
  "SipTimeoutSettings": {
    "kind": "class",
    "text": "Настройки максимального времени общения и дозвона",
    "fields": {
      /**
       * Максимальное время дозвона в секундах
       */
      "callTimeout": {
        "type": "int32",
        "text": "Максимальное время дозвона в секундах",
      },
      /**
       * Максимальное время общения в секундах
       */
      "talkTimeout": {
        "type": "int32",
        "text": "Максимальное время общения в секундах",
      },
    },
  },
  /**
   * Тип состояния Sip-аккаунта
   */
  "GetSipAccountStatusListResponse.SipStatus.StateType": {
    "kind": "enum",
    "text": "Тип состояния Sip-аккаунта",
    "values": {
      /**
       * Значение не указано
       */
      "STATE_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Клиент отправил REGISTER запрос, но ответ от сервера ещё не получен.
       * Идёт попытка регистрации
       */
      "REGISTERING": {
        "i": 1,
        "text": "Клиент отправил REGISTER запрос, но ответ от сервера ещё не получен.\nИдёт попытка регистрации",
      },
      /**
       * Успешная регистрация.
       * SIP-сервер подтвердил регистрацию, клиент готов принимать звонки
       */
      "REGISTERED": {
        "i": 2,
        "text": "Успешная регистрация.\nSIP-сервер подтвердил регистрацию, клиент готов принимать звонки",
      },
      /**
       * Клиент отключился или не регистрировался.
       * Возможные причины: Клиент отправил UNREGISTER; Истек срок регистрации (expires)
       */
      "UNREGISTERED": {
        "i": 3,
        "text": "Клиент отключился или не регистрировался.\nВозможные причины: Клиент отправил UNREGISTER; Истек срок регистрации (expires)",
      },
      /**
       * Ошибка при попытке регистрации.
       * Возможные причины: Неверный логин/пароль; SIP-сервер недоступен; Ошибка в конфигурации (порт, протокол, IP)
       */
      "REGISTRATION_FAILED": {
        "i": 4,
        "text": "Ошибка при попытке регистрации.\nВозможные причины: Неверный логин/пароль; SIP-сервер недоступен; Ошибка в конфигурации (порт, протокол, IP)",
      },
      /**
       * Нет ответа от сервера в течение времени ожидания.
       * Возможные причины: Проблемы с сетью; SIP-сервер не отвечает; Нет ответа от сервера в течение времени ожидания
       */
      "TIMEOUT": {
        "i": 5,
        "text": "Нет ответа от сервера в течение времени ожидания.\nВозможные причины: Проблемы с сетью; SIP-сервер не отвечает; Нет ответа от сервера в течение времени ожидания",
      },
      /**
       * SIP клиент остановлен вручную или отключён по конфигурации.
       * Не выполняется даже попытка регистрации
       */
      "DISABLED": {
        "i": 6,
        "text": "SIP клиент остановлен вручную или отключён по конфигурации.\nНе выполняется даже попытка регистрации",
      },
    },
  },
}